import { NavButton } from "./NavigationBar";

export const ConstructionPage = () => {
    return (
        <div className="flex h-screen flex-col text-center">
        
            <div className="w-10/12 h-56 md:h-40 m-auto place-self-center bg-red-500 text-2xl md:text-5xl p-10 rounded-lg drop-shadow-lg"> 
                🚧 Sorry! Page is probably still under construction! 🚧 
                <div className="text-sm w-7/12 md:w-2/12 h-32 md:text-lg m-auto mt-3">
                    <NavButton buttonName={'Go Back Home'} redirectPath={'/personal-site/#'} />
                </div>
            </div>
            
        </div>
    );
}

export default ConstructionPage;
